export const clone: (source: object) => object = source => JSON.parse(JSON.stringify(source))
